import axios from "axios";
import { authApi } from "@/features/auth/api/auth.api";

export const apiClient = axios.create({
  baseURL: import.meta.env.VITE_API_URL,
  paramsSerializer: (params: Record<string, unknown>) => {
    const searchParams = new URLSearchParams()
    for (const [key, value] of Object.entries(params)) {
      if (value === undefined || value === null) continue
      if (Array.isArray(value)) {
        for (const v of value) searchParams.append(key, String(v))
      } else {
        searchParams.append(key, String(value))
      }
    }
    return searchParams.toString()
  },
});

apiClient.interceptors.request.use(
  async (config) => {
    const jwt = await authApi.getJwt();

    if (jwt) {
      config.headers.Authorization = `Bearer ${jwt}`;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
